import { useDispatch, useSelector } from 'react-redux';
import {
  deleteInvitationGroup,
  isDeleteInvitationGroupPanelOpenSelector,
  setIsDeleteInvitationGroupPanelOpen,
} from '../../../../../../../features/pageFeatures/invitationGroupAdministrationPageSlice';
import { noSelectionKey } from '../../../../../../../utilities/filterAndSortingsUtil';

export const useDeleteInvitationGroup = (
  selectedInvitationGroupKey,
  setSelectedInvitationGroupKey,
) => {
  const dispatch = useDispatch();

  const isPopupOpen = useSelector(isDeleteInvitationGroupPanelOpenSelector);

  function setIsPopupOpen() {
    dispatch(setIsDeleteInvitationGroupPanelOpen(false));
  }

  function onConfirm() {
    dispatch(deleteInvitationGroup(selectedInvitationGroupKey));
    setSelectedInvitationGroupKey(noSelectionKey);
  }

  return {
    isPopupOpen,
    setIsPopupOpen,
    onConfirm,
  };
};
